var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "section tab-data-tracking" }, [
      _c("div", { staticStyle: { "min-width": "fit-content" } }, [
        _c("div", { staticClass: " basic-info" }, [
          _c("div", { staticClass: "basic-info-left" }, [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("p", { staticClass: "basic-info-mbl" }, [_vm._v("B/L:")]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "250px" },
                    attrs: { no: "mblNo" },
                    model: {
                      value: _vm.mblNo,
                      callback: function($$v) {
                        _vm.mblNo = $$v
                      },
                      expression: "mblNo"
                    }
                  },
                  _vm._l(_vm.blNoArray, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      staticStyle: {
                        "font-size": "22px",
                        "font-weight": "400"
                      },
                      attrs: { label: item.code, value: item.value }
                    })
                  }),
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "7px" },
                    attrs: { no: "onDownloadTemplate", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.onDownloadTemplate()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.DownloadPortServiceScope")))]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "basic-info-port" },
              [
                _c("port-item", {
                  attrs: {
                    no: "portOfLoading",
                    icon: "/static/data_tracking/u7.png",
                    title: _vm.$t("Payment.portOfLoading"),
                    value: _vm.basicInfo.loadingPort
                  }
                }),
                _c("port-item", {
                  attrs: {
                    no: "portOfDestination",
                    icon: "/static/data_tracking/u8.png",
                    title: _vm.$t("Payment.portOfDestination"),
                    value: _vm.basicInfo.destinationPort
                  }
                }),
                _c("port-item", {
                  attrs: {
                    no: "ContainerAmount",
                    icon: "/static/data_tracking/u22.png",
                    title: _vm.$t("SeaExport.ContainerAmount"),
                    value: String(_vm.jobContainerNum)
                  }
                })
              ],
              1
            )
          ])
        ]),
        _c("div", { staticStyle: { display: "flex" } }, [
          _c("div", { staticClass: "instructions" }, [
            _c("span", { staticStyle: { color: "#1F75D5" } }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.thirdPartyPrompt")))
            ]),
            _c("span", { staticStyle: { color: "#efb336" } }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.manualPrompt")))
            ]),
            _c("span", { staticStyle: { color: "#CCCCCC" } }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.promptNo")))
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "step-info" },
          [
            _c(
              "el-steps",
              { staticClass: "steps" },
              _vm._l(_vm.stepList, function(step) {
                return _c(
                  "el-step",
                  {
                    key: step.type,
                    staticStyle: { position: "relative" },
                    attrs: {
                      title: step.name,
                      status: step.manualIsFinish
                        ? "process"
                        : step.isFinish
                        ? "finish"
                        : "wait"
                    }
                  },
                  [
                    _c("template", { slot: "icon" }, [
                      _c("img", {
                        attrs: {
                          src:
                            "/static/data_tracking/" +
                            (step.manualIsFinish ? step.manualIcon : step.icon)
                        }
                      })
                    ]),
                    _c("template", { slot: "description" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: step.showTime,
                              expression: "step.showTime"
                            }
                          ]
                        },
                        [_vm._v(_vm._s(step.time))]
                      ),
                      _c("div", { staticStyle: { clear: "both" } }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: step.showNum && !step.manualIsFinish,
                              expression: "step.showNum && !step.manualIsFinish"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.ContainerQuantity") +
                                (step.containerNum > _vm.jobContainerNum
                                  ? _vm.jobContainerNum
                                  : step.containerNum) +
                                "/" +
                                _vm.jobContainerNum
                            )
                          )
                        ]
                      )
                    ]),
                    _c("template", { slot: "description" }, [
                      _c(
                        "div",
                        {
                          staticClass: "planned",
                          class: [
                            !step.plannedTime
                              ? "grey"
                              : step.plannedColor
                              ? "blue"
                              : "orange",
                            step.time ? "top" : ""
                          ]
                        },
                        [
                          step.type === "actualBerthPlanDate"
                            ? _c(
                                "span",
                                { staticStyle: { "font-size": "16px" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PlannedBerthing"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          step.type === "actualUnberthPlanDate"
                            ? _c(
                                "span",
                                { staticStyle: { "font-size": "16px" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PlanDeparture"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c("span", [_vm._v(_vm._s(step.plannedTime))])
                        ]
                      )
                    ])
                  ],
                  2
                )
              }),
              1
            )
          ],
          1
        ),
        _vm.isViewContainerInformation
          ? _c("div", { staticClass: "app-main-inner-row container-info" }, [
              _c(
                "div",
                { ref: "refName", staticClass: "container-info-title title" },
                [
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))
                  ]),
                  _c("h2", [_vm._v("Container information")])
                ]
              ),
              _c("div", { staticClass: "container-info-main" }, [
                _c("div", { staticClass: "container-info-list" }, [
                  _c(
                    "ul",
                    _vm._l(_vm.containerList, function(container) {
                      return _c(
                        "li",
                        {
                          key: container.containerNo,
                          class:
                            _vm.curContainer === container.containerNo
                              ? "isActive"
                              : "",
                          on: {
                            click: function($event) {
                              return _vm.changeContainer(container)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s("" + container.containerNo))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _c("div", { staticClass: "container-info-details" }, [
                  _c("div", { staticClass: "container-info-left" }, [
                    _c(
                      "section",
                      { staticClass: "container-info-section" },
                      [
                        _c("p", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("SeaExport.DetailedData")))
                        ]),
                        _c("details-table", {
                          attrs: { details: _vm.containerInfo, job: _vm.job }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ]),
      _c(
        "div",
        { staticClass: "hideWire" },
        [
          _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              attrs: {
                visible: _vm.dialogVisible,
                modal: false,
                "close-on-press-escape": false,
                "close-on-click-modal": false,
                width: "450px",
                "before-close": _vm.cancel
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                }
              }
            },
            [
              _c("div", { staticClass: "text" }, [
                _c("i", { staticClass: "el-icon-warning" }),
                _c("div", { staticStyle: { "font-size": "14px" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("SeaExport.DetectionOfBasicTab"))),
                  _c("span", { staticClass: "red" }, [
                    _vm._v(
                      _vm._s(_vm.containersText.toString().replaceAll("、"))
                    )
                  ]),
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.InconsistentThePortAreaReturn"))
                  ),
                  _c("span", { staticClass: "red" }, [
                    _vm._v(
                      _vm._s(_vm.containersText.toString().replaceAll("、"))
                    )
                  ]),
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.PleaseTheOperationIsCorrect")) +
                      " "
                  ),
                  _c("br"),
                  _vm._v(_vm._s(_vm.$t("SeaExport.YouBoxAndCargoTab")) + " "),
                  _c("br"),
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "SeaExport.InconsistencyBetweenPortAreaDataAndPackingInformationTips"
                      )
                    ) + " "
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }